import React, { useState, useEffect } from 'react';
import CashierCloseSimple from './cashierCloseSimple';

// Custom event name for opening the cashier close dialog
export const OPEN_CASHIER_CLOSE_EVENT = 'openCashierClose';

// Function to dispatch the custom event
export const openCashierClose = () => {
  const event = new CustomEvent(OPEN_CASHIER_CLOSE_EVENT);
  window.dispatchEvent(event);
};

const CashierCloseManager: React.FC = () => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  useEffect(() => {
    // Add event listener for the custom event
    const handleOpenDialog = () => {
      setShowDialog(true);
    };

    window.addEventListener(OPEN_CASHIER_CLOSE_EVENT, handleOpenDialog);

    // Clean up event listener
    return () => {
      window.removeEventListener(OPEN_CASHIER_CLOSE_EVENT, handleOpenDialog);
    };
  }, []);

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  return <CashierCloseSimple isOpen={showDialog} onClose={handleCloseDialog} />;
};

export default CashierCloseManager;
